define([
    "angular",
    "angular-sanitize"
], function (angular) {
    "use strict";

    return angular.module("sanitizeModule", ["ngSanitize"]);
});